// @ts-nocheck

export const init = function () {
  var w = window;
  w.OlvyConfig = {
    workspaceAlias: "shelfcycle",
  };
  var d = document;
  var widgetSrc = "https://app.olvy.co/scriptV2.js";
  function r() {
    if (d.querySelector(`script[src="${widgetSrc}"`)) {
      return;
    }
    var s = d.createElement("script");
    s.async = 1;
    s.type = "text/javascript";
    s.src = widgetSrc;
    (d.body || d.head).appendChild(s);
  }
  if (d.readyState === "complete") {
    r();
  } else if (w.attachEvent) {
    w.attachEvent("onload", r);
  } else {
    w.addEventListener("load", r, false);
  }
};
